import { TableCell, TableRow } from "@pushpress/pushpress-ui";
import { Search } from "lucide-react";

export default function EmptyTableView() {
  return (
    <TableRow>
      <TableCell colSpan={3} className="tw-h-24 tw-text-center tw-p-16">
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-2 tw-p-16">
          <Search className="tw-h-8 tw-w-8 tw-text-muted-foreground" />
          <p className="tw-text-lg tw-font-medium">No data yet</p>
        </div>
      </TableCell>
    </TableRow>
  );
}
